import { render, staticRenderFns } from "./report-status-client.vue?vue&type=template&id=5deb8942"
import script from "./report-status-client.vue?vue&type=script&lang=js"
export * from "./report-status-client.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports